import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ProductSelectFilterComponent} from '../../../../product/api/component/product-select-filter/product-select-filter.component';
import {ProductModalOptions} from '../../../../product/api/component/product-select-filter/productModalOptions';
import {ProductSummaryModel} from '../../../../product/api/entity/productSummary.model';

@Component({
    selector: 'app-sale-save-product-form',
    templateUrl: './sale-save-product-form.component.html',
})
export class SaleSaveProductFormComponent implements OnInit, OnChanges {

    @Input() type: string;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() productType: string;
    @ViewChild('productSelectFilter') productSelectFilter: ProductSelectFilterComponent;

    get isSimple(): boolean {
        return this.type === 'SIMPLE';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['type'] && !changes['type'].isFirstChange()) {
            this.disableFormControls();
        }
    }

    disableFormControls() {
        if (!this.isSimple) {
            this.totalPriceVatIncludedControl.disable();
        } else {
            this.totalPriceVatIncludedControl.enable();
        }
        this.totalPriceVatExcludedControl.disable();
    }

    productChanged(product: ProductSummaryModel) {
        this.parentFormGroup.controls.deposit.setValue(product.advanceVatIncluded);
    }

    get quantityControl(): UntypedFormControl {
        return this.parentFormGroup.controls.quantity as UntypedFormControl;
    }

    get totalPriceVatExcludedControl(): UntypedFormControl {
        return this.parentFormGroup.controls.totalPriceVatExcluded as UntypedFormControl;
    }

    get totalPriceVatIncludedControl(): UntypedFormControl {
        return this.parentFormGroup.controls.totalPriceVatIncluded as UntypedFormControl;
    }

    get unitPriceVatIncluded(): UntypedFormControl {
        return this.parentFormGroup.controls.unitPriceVatIncluded as UntypedFormControl;
    }

    get unitPriceVatExcluded(): UntypedFormControl {
        return this.parentFormGroup.controls.unitPriceVatExcluded as UntypedFormControl;
    }

    get productIdControl(): UntypedFormControl {
        return this.parentFormGroup.controls.productId as UntypedFormControl;
    }

    get productModalOption(): ProductModalOptions {
        return {
            typeValue: this.productType
        };
    }

    get taxPercentageControl(): UntypedFormControl {
        return this.parentFormGroup.controls.taxPercentage as UntypedFormControl;
    }

    ngOnInit() {
        this.productIdControl.valueChanges.subscribe(() => {
            const product: ProductSummaryModel = this.productSelectFilter.getSelectedElement();
            const taxPercentage = product.taxPercentage;
            const unitPrice = product.priceVatExcluded;
            if (taxPercentage) {
                this.taxPercentageControl.setValue(taxPercentage, {emitEvent: false});
            }
            if (unitPrice) {
                this.unitPriceVatExcluded.setValue(unitPrice, {emitEvent: false});
                this.updateTotalPriceVatExcluded();
            }

            this.updateUnitPriceVatIncluded();
            this.updateTotalPriceVatIncluded();
        });

        this.taxPercentageControl.valueChanges.subscribe((value) => {
            this.updateUnitPriceVatIncluded();
            this.updateTotalPriceVatIncluded();
            this.updateTotalPriceVatExcluded();
            this.taxPercentageControl.setValue(this.roundNumber(value), {emitEvent: false});
        });

        this.unitPriceVatExcluded.valueChanges.subscribe((value) => {
            this.updateUnitPriceVatIncluded();
            this.unitPriceVatExcluded.setValue(this.roundNumber(value), {emitEvent: false});
            this.updateTotalPriceVatIncluded();
            this.updateTotalPriceVatExcluded();
        });
        this.unitPriceVatIncluded.valueChanges.subscribe((value) => {
            this.updateUnitPriceVatExcluded();
            this.unitPriceVatIncluded.setValue(this.roundNumber(value), {emitEvent: false});
            this.updateTotalPriceVatIncluded();
            this.updateTotalPriceVatExcluded();
        });
        this.quantityControl.valueChanges.subscribe((value) => {
            this.quantityControl.setValue(Math.round(value), {emitEvent: false});
            this.updateTotalPriceVatIncluded();
            this.updateTotalPriceVatExcluded();

        });

    }

    updateUnitPriceVatIncluded() {
        const taxPercentage = this.taxPercentageControl.value;
        const price = this.unitPriceVatExcluded.value * (1 + (taxPercentage / 100));
        this.unitPriceVatIncluded.setValue(this.roundNumber(price), {emitEvent: false});
    }

    updateUnitPriceVatExcluded() {
        const taxPercentage = this.taxPercentageControl.value;
        const ratio = 1 + (taxPercentage / 100);
        const calculatedValue = ratio !== 0 ? (this.unitPriceVatIncluded.value / ratio) : 0;
        this.unitPriceVatExcluded.setValue(this.roundNumber(calculatedValue), {emitEvent: false});
    }

    updateTotalPriceVatIncluded() {
        const price = this.quantityControl.value * this.unitPriceVatIncluded.value;
        this.totalPriceVatIncludedControl.setValue(this.roundNumber(price), {emitEvent: false});
    }

    updateTotalPriceVatExcluded() {
        const price = this.quantityControl.value * this.unitPriceVatExcluded.value;
        this.totalPriceVatExcludedControl.setValue(this.roundNumber(price), {emitEvent: false});
    }

    private roundNumber(nb: number): number {
        return Math.round(nb * 100) / 100;
    }


}
